import React from 'react';
import AdminManagement from '@/components/admin/AdminManagement';

const AdminManagementPage: React.FC = () => {
  return <AdminManagement />;
};

export default AdminManagementPage;